import React, {useState} from 'react';
import { Stepper } from 'react-form-stepper';
import PageHeader from "../../components/PageHeader";
import IdentifyInformationStep from './Steps/IdentifyInformationStep';
import AccountInformationStep from './Steps/AccountInformationStep';
import AddressInformationStep from './Steps/AddressInformation';
import CreditInformationStep from './Steps/CreditInformationStep';
import PasswordInformationStep from './Steps/PasswordInformationStep';


const EditIdentifyPage = () => {
    const [activeStep, setActiveStep] = useState(0);

    const stepForm = [
        {
            id: 1,
            component: (
                <IdentifyInformationStep activeStep={activeStep} setActiveStep={setActiveStep}  />
            ),
        },
        {
            id: 2,
            component: (
                <AccountInformationStep activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 2,
            component: (
                <AddressInformationStep activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 4,
            component: (
                <CreditInformationStep activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 5,
            component: (
                <PasswordInformationStep activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        // { id: 4, component: <StepOne activeStep={activeStep} /> },
    ];
    return (
        <>
            <PageHeader name="Edit Identify"/>
            <div>
                <Stepper
                    steps={[{ label: 'Identify Information' }, { label: 'Account Information' }, { label: 'Address Information' }, { label: 'Credit Information' }, { label: 'Password Information' }]}
                    styleConfig={{
                        activeBgColor: "rgba(45, 51, 61, 0.6)",
                        activeTextColor: "#fff",
                        inactiveBgColor: "#fff",
                        inactiveTextColor: "#999",
                        completedBgColor: "rgb(45, 51, 61)",
                        completedTextColor: "#fff",
                        size: "2em",
                    }}
                    activeStep={activeStep+1}
                />
            </div>

            {stepForm[activeStep].component}
        </>
    );
};

export default EditIdentifyPage;